import React, {Component} from 'react';

import ToggleInput from '../../../../../components/ToggleInput/toggleInput';
import formatters from "../../../../../utils/formatters";


export default class TripDocControl extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let form = (
            <div>
                <div className={"row margin-top-20"}>
                    <div className={"col s3 offset-s1"}>
                        <ToggleInput
                            selected={trip.quality_letter_check}
                            name={'Documentación'}
                        />
                        {trip.quality_letter_check &&
                        <div className="input-subtitle green-text">Documentación aprobada</div>
                        }
                        {trip.quality_letter_check === false &&
                        <div className="input-subtitle red-text">Documentación rechazada</div>
                        }
                    </div>
                    <div className={"col s4 offset-s1 input-field input-grey"}>
                        <label className="active">Cantidad de cisternas</label>
                        <p className={"field-p-no-border"}>{formatters.intFormat(trip.compartments)}</p>
                    </div>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Control de Documentación</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripDocControl.js